import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=d150a466&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=d150a466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d150a466",
  null
  
)

export default component.exports